/**
 * @param pluginObj
 * @param key
 */
export function instancePropertyGet(pluginObj, key) {
    if (pluginObj._objectInstance && pluginObj._objectInstance[key]) {
        return pluginObj._objectInstance[key];
    }
    return null;
}
/**
 * @param pluginObj
 * @param key
 * @param value
 */
export function instancePropertySet(pluginObj, key, value) {
    if (pluginObj._objectInstance) {
        pluginObj._objectInstance[key] = value;
    }
}
//# sourceMappingURL=instance-property.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awesome-cordova-plugins/core/decorators/instance-property.js
// module id = 968
// module chunks = 214